import React from 'react';
import PropTypes from 'prop-types';
import { TrendingUp } from '@mui/icons-material';

import colors from '../../../../styles/colors';
import {
  Badge,
  PreviousValue,
  Arrow,
  CurrentValue,
} from './styles';

const REPS_METRIC = 'reps';

const WorkoutProgressionBadge = ({
  metric,
  previousValue,
  currentValue,
  unit,
}) => {
  const format = (value) => (metric === REPS_METRIC ? `${value} ${unit}` : `${value}${unit}`);

  return (
    <Badge>
      <TrendingUp style={{ fontSize: 12, color: colors.shades.success8 }} />
      <PreviousValue>{format(previousValue)}</PreviousValue>
      <Arrow>→</Arrow>
      <CurrentValue>{format(currentValue)}</CurrentValue>
    </Badge>
  );
};

WorkoutProgressionBadge.propTypes = {
  metric: PropTypes.oneOf(['weight', 'reps', 'time']).isRequired,
  previousValue: PropTypes.number.isRequired,
  currentValue: PropTypes.number.isRequired,
  unit: PropTypes.string.isRequired,
};

export default WorkoutProgressionBadge;
